var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { validationMixin } from 'vuelidate';
import { alphaWithSpaces, pnr, ticketNumber } from 'utils/validators';
import { minLength, or, required } from 'vuelidate/lib/validators';
import ButtonBlue from 'components/Buttons/Blue.vue';
import InputElement from 'components/Elements/Input.vue';
import FormMixin from 'components/Forms/FormMixin';
import UrlParams from 'utils/UrlParams';
var FormErrors = function () {
    return import(/* webpackChunkName: "form-errors" */ 'components/FormErrors/FormErrors.vue');
};
var FormErrorItem = function () {
    return import(
    /* webpackChunkName: "form-error-item" */ 'components/FormErrors/FormErrorItem.vue');
};
var PnrValidationForm = /** @class */ (function (_super) {
    __extends(PnrValidationForm, _super);
    function PnrValidationForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = { pnr: '', surname: '' };
        _this.validationErrorMsg = '';
        return _this;
    }
    Object.defineProperty(PnrValidationForm.prototype, "errorVisible", {
        get: function () {
            return this.hasError('pnr') || this.hasError('surname');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PnrValidationForm.prototype, "mappedErrorMessages", {
        get: function () {
            var pnr = this.getErrorMsg('pnr');
            var surname = this.getErrorMsg('surname');
            if (!this.validationErrorMsg.length) {
                return [pnr, surname];
            }
            return [pnr, surname, this.validationErrorMsg];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PnrValidationForm.prototype, "errorMessages", {
        get: function () {
            return {
                pnr: {
                    pnrOrTicketNumber: 'reusable.pnr.validation.invalid',
                    required: 'reusable.pnr.validation.missingValue'
                },
                surname: {
                    alphaWithSpaces: 'reusable.surname.validation.onlyLatin',
                    minLength: 'reusable.surname.validation.missingValue',
                    required: 'reusable.surname.validation.missingValue'
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    PnrValidationForm.prototype.formatValue = function (key) {
        this.form[key] = this.form[key].toUpperCase().trim();
    };
    PnrValidationForm.prototype.hasError = function (field) {
        return this.$_formMixin_hasError(this.$v.form, field);
    };
    PnrValidationForm.prototype.getErrorMsg = function (field) {
        return this.$_formMixin_errorMsg(this.$v.form, this.errorMessages, field);
    };
    PnrValidationForm.prototype.validate = function () {
        var _this = this;
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
            return;
        }
        var _a = this.form, pnr = _a.pnr, surname = _a.surname;
        this.$store
            .dispatch('bookingValidation/validatePnr', { pnrRl: pnr, surname: surname })
            .then(function () {
            _this.$emit('success', pnr);
        })
            .catch(function (error) {
            _this.validationErrorMsg = error;
        });
    };
    PnrValidationForm.prototype.mounted = function () {
        var pnr = UrlParams.getUrlParam(window.location.href, 'pnr') || '';
        var lastName = UrlParams.getUrlParam(window.location.href, 'lastName') || '';
        this.form.pnr = pnr;
        this.form.surname = lastName;
        if (this.form.pnr !== '' && this.form.surname !== '') {
            this.validate();
        }
    };
    PnrValidationForm = __decorate([
        Component({
            mixins: [validationMixin, FormMixin],
            components: {
                ButtonBlue: ButtonBlue,
                InputElement: InputElement,
                FormErrorItem: FormErrorItem,
                FormErrors: FormErrors
            },
            validations: {
                form: {
                    pnr: {
                        pnrOrTicketNumber: or(pnr, ticketNumber),
                        required: required
                    },
                    surname: {
                        alphaWithSpaces: alphaWithSpaces,
                        minLength: minLength(2),
                        required: required
                    }
                }
            }
        })
    ], PnrValidationForm);
    return PnrValidationForm;
}(Vue));
export default PnrValidationForm;
